/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SmallAttachment,
    SmallAttachmentFromJSON,
    SmallAttachmentFromJSONTyped,
    SmallAttachmentToJSON,
} from './';

/**
 * 
 * @export
 * @interface Document
 */
export interface Document {
    /**
     * 
     * @type {number}
     * @memberof Document
     */
    owner?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Document
     */
    deal: number;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    type: DocumentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    series?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    divisionCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    issuedByWhom?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Document
     */
    dateOfIssue?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    citizenship?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    placeOfBirth?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Document
     */
    bankId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Document
     */
    readonly id?: number;
    /**
     * 
     * @type {Date}
     * @memberof Document
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Document
     */
    readonly updatedAt?: Date;
    /**
     * 
     * @type {Array<SmallAttachment>}
     * @memberof Document
     */
    readonly attachments?: Array<SmallAttachment>;
}

export function DocumentFromJSON(json: any): Document {
    return DocumentFromJSONTyped(json, false);
}

export function DocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Document {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'owner': !exists(json, 'owner') ? undefined : json['owner'],
        'deal': json['deal'],
        'type': json['type'],
        'series': !exists(json, 'series') ? undefined : json['series'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'divisionCode': !exists(json, 'divisionCode') ? undefined : json['divisionCode'],
        'issuedByWhom': !exists(json, 'issuedByWhom') ? undefined : json['issuedByWhom'],
        'dateOfIssue': !exists(json, 'dateOfIssue') ? undefined : (json['dateOfIssue'] === null ? null : new Date(json['dateOfIssue'])),
        'country': !exists(json, 'country') ? undefined : json['country'],
        'citizenship': !exists(json, 'citizenship') ? undefined : json['citizenship'],
        'placeOfBirth': !exists(json, 'placeOfBirth') ? undefined : json['placeOfBirth'],
        'bankId': !exists(json, 'bankId') ? undefined : json['bankId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'attachments': !exists(json, 'attachments') ? undefined : ((json['attachments'] as Array<any>).map(SmallAttachmentFromJSON)),
    };
}

export function DocumentToJSON(value?: Document | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'owner': value.owner,
        'deal': value.deal,
        'type': value.type,
        'series': value.series,
        'number': value.number,
        'divisionCode': value.divisionCode,
        'issuedByWhom': value.issuedByWhom,
        'dateOfIssue': value.dateOfIssue === undefined ? undefined : (value.dateOfIssue === null ? null : value.dateOfIssue.toISOString().substr(0,10)),
        'country': value.country,
        'citizenship': value.citizenship,
        'placeOfBirth': value.placeOfBirth,
        'bankId': value.bankId,
    };
}

/**
* @export
* @enum {string}
*/
export enum DocumentTypeEnum {
    Passport = 'passport',
    Inn = 'inn',
    Snils = 'snils',
    BirthCertificate = 'birth_certificate',
    ChildRepresentativeApproval = 'child_representative_approval',
    MarriageContract = 'marriage_contract',
    SpousesNotarialConsent = 'spouses_notarial_consent',
    PassportOriginal = 'passport_original',
    Apostille = 'apostille',
    MaternalCapitalCertificate = 'maternal_capital_certificate',
    MortgageCertificate = 'mortgage_certificate',
    SubsidyCertificate = 'subsidy_certificate'
}


